import { useField, useFormikContext } from "formik";
import { useTranslation } from "react-i18next";
import {
    DisplayFormErrors,
    InputField,
    VerticalForm,
} from "melco-shared-logic";
import { Alert, Button, FullWidthSpace, PlusIcon, SaveIcon, Text, Title, useMessage } from "melco-ui";
import { SelectPartnerField } from "./SelectPartnerField";

type DisplayAddIntegrationFormProps = {
    isLoading: boolean;
};

export const DisplayAddIntegrationForm: React.FC<
    DisplayAddIntegrationFormProps
> = ({ isLoading }) => {
    const { t } = useTranslation();
    const message = useMessage();
    const { handleSubmit } = useFormikContext();
    const [{ value: partnerValue }] = useField("partner");

    return (
        <VerticalForm>
            <DisplayFormErrors />
            <FullWidthSpace direction="vertical" size="middle">
                {/* <InputField
                name="name"
                label={t("api_list.actions.add.form.label.name")}
            /> */}

                <SelectPartnerField />

                {/*    <SelectAddIntegrationScopeField /> */}


                {partnerValue === "CUSTOM" && <FullWidthSpace direction="vertical" size="xsmall">
                    <InputField
                        name="name"
                        label={t("eodsettings.actions.add.form.label.name")}
                    />
                    <Title level={5}>{t("eodsettings.actions.add.form.label.barcode")}</Title>
                    <Text>{t("eodsettings.actions.add.form.label.url_text")}</Text>
                    <InputField
                        name="url"
                        label={t("eodsettings.actions.add.form.label.url")}
                        placeholder="https://www.melco.com/eod/orders/{BARCODE}"
                        info={
                            <>{t("eodsettings.actions.add.form.label.url_info")}
                                <Text
                                    code
                                    copyable={{
                                        onCopy: () => {
                                            message.success(t("eodsettings.actions.add.form.copy.url.success"));
                                        },
                                        tooltips: [
                                            t("eodsettings.actions.add.form.copy.url.tooltip_copy"),
                                            t("eodsettings.actions.add.form.copy.url.tooltip_copied"),
                                        ],
                                    }}
                                >
                                    {"{BARCODE}"}
                                </Text></>}
                    />
                </FullWidthSpace>}

                <Title level={5}>{t("eodsettings.actions.add.form.label.configuration")}</Title>
                <Alert
                    type="info"
                    closable={false}
                    message={
                        <Text>{t("eodsettings.actions.add.form.label.configinfo")}</Text>
                    }
                    withBackground
                // style={{ width: "100%" }}
                />
                <Button
                    key="submit-add-integration-form"
                    type="primary"
                    icon={<SaveIcon />}
                    disabled={isLoading}
                    loading={isLoading}
                    onClick={() => handleSubmit()}
                >
                    {t("eodsettings.actions.add.form.submit_button")}
                </Button>
            </FullWidthSpace>
        </VerticalForm>
    );
};
